// 兵糧の表示を時間の分だけ進める計算（サーバーの回復と同じ：nextAt ごとに1、本体が上限なら予備へ、満タンで止まる）
export interface StaminaLike {
  value: number;
  reserve: number;
  max: number;
  reserveMax: number;
  nextAt: number | null;
}

/** now までに回復した分を足した値（変わらなければ同じオブジェクト） */
export function advanceStamina<T extends StaminaLike>(st: T, now: number, periodMs: number): T {
  if (st.nextAt == null || now < st.nextAt) return st;
  let { value, reserve } = st;
  let nextAt: number | null = st.nextAt;
  while (nextAt != null && now >= nextAt) {
    if (value < st.max) value++;
    else if (reserve < st.reserveMax) reserve++;
    nextAt = value >= st.max && reserve >= st.reserveMax ? null : nextAt + periodMs;
  }
  return { ...st, value, reserve, nextAt };
}
